module.exports = __webpack_public_path__ + "static/ava-digital-badge-mobile.d4a015f8.webp";